import React, { useState, useContext } from "react";
import NavBarTop from '../../NavBar_Top/NavBar_Top';
import Esqueci_Minha_Senha_Pagina from '../../Pages/Esqueci_Minha_Senha/Esqueci_Minha_Senha_Pagina';
import Rodape from '../../Rodape/Rodape';
import { useHistory } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import { identificacaoUsuarioLogado } from '../../../utils';
import 'react-toastify/dist/ReactToastify.css';
import { MyContext } from '../../../context/MyContext';

function Esqueci_Minha_Senha() {
  let history = useHistory();
  // const toastMensagemErrorBKPComRedirecionamento = (message) => toast.error(message,{ position: toast.POSITION.BOTTOM_CENTER, theme: "colored", autoClose: 2000, onClose: () => { redirecionarPagina(); } });
  // const toastMensagemErrorLoginBKPComRedirecionamento = (message) => toast.error(message,  { position: toast.POSITION.BOTTOM_CENTER, theme: "colored", autoClose: 2000, onClose: () => { redirecionarPaginaLogin(); } });    
  const toastMensagemError = (message) => toast.error(message, { position: toast.POSITION.BOTTOM_CENTER, theme: "colored", autoClose: 2000 });
 
  const toastMensagemErrorLogin = (message) => toast.error(message, { position: toast.POSITION.BOTTOM_CENTER, theme: "colored", autoClose: 2000 });    

  const { destinoPagina, setDestinoPagina } = useContext(MyContext);  
  const [showingToast, setShowingToast] = useState(0);
  const [showingToastNeedLogin, setShowingToastNeedLogin] = useState(1);
  let usuarioComprasFaturado = sessionStorage.getItem("usuario_compras_faturado");

  return (
    <div>
      <NavBarTop />
      <Esqueci_Minha_Senha_Pagina />
      <ToastContainer />
      <Rodape />
    </div>
  )

}
export default Esqueci_Minha_Senha